<template>
  <AppLayout class="microsites" centered customToolbar>
    <template v-slot:body>
      <div class="worker-details container col-lg-10 col-sm-12">
        <BackBar parent="/settings/microsites" title="Microsites" />
        <div v-if="isFetchingMicrosite">
          <v-skeleton-loader v-for="i in 5" :key="i" type="list-item" />
        </div>
        <div v-else>
          <div class="d-flex justify-center mb-2">
            <h1>{{ currentMicrosite.name }}</h1>
            <PrimaryButton
              class="ml-2"
              dense
              shrink
              light
              @click.native="openDialog('editTitle')"
            >
              Edit <v-icon>mdi-pencil</v-icon>
            </PrimaryButton>
          </div>
          <div class="d-flex justify-center mb-4">
            <PrimaryButton
              dense
              shrink
              text
              @click.native="openSite"
              v-if="currentPages.length"
            >
              View Site
              <v-icon color="primary" class="ml-1">
                mdi-open-in-new
              </v-icon>
            </PrimaryButton>
          </div>
          <h2>Pages</h2>
          <div class="pages my-4">
            <draggable v-model="pages">
              <v-list-item v-for="(page, index) in pages" :key="page.id">
                <PageItem
                  :micrositeId="currentMicrositeId"
                  :page="page"
                  :displayOrder="index"
                />
              </v-list-item>
            </draggable>
          </div>
        </div>
        <PrimaryButton
          class="my-4"
          full-width
          light
          @click.native="openDialog('addPage')"
        >
          Add Page
          <v-icon>mdi-plus</v-icon>
        </PrimaryButton>
        <NewPageDialog
          @close="closeDialog('addPage')"
          :displayOrder="displayOrder"
          :micrositeId="currentMicrositeId"
          :isOpen="isOpen.addPage"
          v-if="isOpen.addPage"
        />
        <EditMicrositeDialog
          isUpdate
          v-if="isOpen.editTitle"
          :isOpen="isOpen.editTitle"
          :microsite="currentMicrosite"
          @close="closeDialog('editTitle')"
        />
      </div>
    </template>
  </AppLayout>
</template>

<script>
import AppLayout from "@/components/common/base-layouts/AppLayout";
import BackBar from "@/components/common/base-layouts/BackBar";
import { createNamespacedHelpers } from "vuex";
import { MICROSITE_NAMESPACE } from "@/store/modules/microsites";
import {
  FETCH_MICROSITE,
  UPDATE_PAGE_ORDER
} from "@/store/modules/microsites/actions";
import { copyState } from "@/utils/helpers";
import PrimaryButton from "@/components/common/Button/PrimaryButton";
import NewPageDialog from "@/views/settings/components/microsites/components/dialogs/PageDialog";
import EditMicrositeDialog from "@/views/settings/components/microsites/components/dialogs/MicrositeDialog";
import PageItem from "@/views/settings/components/microsites/components/PageItem";
import draggable from "vuedraggable";

const { mapActions, mapState } = createNamespacedHelpers(MICROSITE_NAMESPACE);

export default {
  name: "TalentPools",
  components: {
    AppLayout,
    BackBar,
    PrimaryButton,
    NewPageDialog,
    EditMicrositeDialog,
    PageItem,
    draggable
  },
  async created() {
    await this.fetchMicrosite(this.currentMicrositeId);
  },
  data() {
    return {
      isOpen: {
        addPage: false,
        editTitle: false
      }
    };
  },
  computed: {
    ...mapState(
      copyState(["currentMicrosite", "isFetchingMicrosite", "currentPages"])
    ),
    currentMicrositeId() {
      return this.$route.params.id;
    },
    pages: {
      get() {
        return this.currentPages;
      },
      set(value) {
        this.updatePageOrder(value);
      }
    },
    displayOrder() {
      return this.currentPages.length;
    },
    siteLink() {
      const { slug } = this.pages[0];
      return `${process.env.VUE_APP_API_URL}/pages/${this.currentMicrosite.slug}/${slug}`;
    }
  },
  methods: {
    ...mapActions({
      fetchMicrosite: FETCH_MICROSITE,
      updatePageOrder: UPDATE_PAGE_ORDER
    }),
    openDialog(key) {
      this.isOpen[key] = true;
    },
    closeDialog(key) {
      this.isOpen[key] = false;
    },
    openSite() {
      window.open(this.siteLink, "_");
    }
  }
};
</script>

<style lang="scss">
.microsites {
  .list-item .v-avatar.v-list-item__avatar {
    background-color: transparent;
  }
  .list-item {
    padding: 0;
  }
}
</style>
